module.exports = __webpack_public_path__ + "src/submodules/base/assets/img/product.67702c97.png";